import React from 'react';
import { Heading, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';
import { useIntl } from 'react-intl';
import { matchTranslate } from '../../util/richText';

const SectionMultiEnumMaybe = props => {
  const { heading, options, selectedOptions } = props;
  const intl = useIntl();

  if (!heading || !options || !selectedOptions) {
    return null;
  }

  return (
    <div className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {matchTranslate(`{{${heading}}}`, intl)}
      </Heading>
      <PropertyGroup
        id="ListingPage.amenities"
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
      />
    </div>
  );
};

export default SectionMultiEnumMaybe;
